import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import depositIcon from '../assets/image/deposite/deposite-icon-1.png';
import crosIcon from '../assets/image/deposite/cros-icon.png';
import localBank from '../assets/image/deposite/Local-bank.png';
import label from '../assets/image/deposite/label.png';
import easypasia from '../assets/image/deposite/Easypasia.png';
import jazzCash from '../assets/image/deposite/Jazz-Cash.png';
import bankCard from '../assets/image/deposite/Bank-Card.png';
import usdt from '../assets/image/deposite/USDT.png';
import trx from '../assets/image/deposite/TRX.png';
import raast from '../assets/image/deposite/RaastPay.webp';
import axios from "axios";
import './deposit.css';
import './TransferModal.css';
import PaymentLoader from "./PaymentLoader";
import PaymentStatus from "./PaymentStatus";
import DepositRecharge from "./DepositRecharge";
import Cookies from 'js-cookie';
import USDTForm from "./USDTForm";

const baseURLAPI = import.meta.env.VITE_BASE_URL_API;

const paymentMethods = [
    { id: 1, name: "P2P Agent", img: localBank },
    { id: 2, name: "EasyPaisa", img: easypasia },
    { id: 3, name: "JazzCash", img: jazzCash },
    // { id: 7, name: "Raast Pay", img: raast },
    { id: 4, name: "Bank Card", img: bankCard, disabled: true }, // Disabled
    { id: 5, name: "USDT", img: usdt },
    { id: 6, name: "TRX", img: trx, disabled: true }, // Disabled
];

const DepositMain = () => {
    const [selectedPayment, setSelectedPayment] = useState(null);
    const [amount, setAmount] = useState("");
    const [phoneNum, setPhoneNum] = useState('');
    const [cnicNumber, setCnicNumber] = useState('');
    const [trancLoading, setTrancLoading] = useState(false);
    const [profile, setProfile] = useState({ data: {} });
    const [paymentStatus, setPaymentStatus] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [error, setError] = useState('');
    const [open, setOpen] = useState(false);
    const [selectedAmount, setSelectedAmount] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [networkLink, setNetworkLink] = useState("");
    const [successModalOpen, setSuccessModalOpen] = useState(false);
    const [currentBalance, setCurrentBalance] = useState(0);

    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        const userId = Cookies.get('user_id');
        if (!userId) {
            navigate('/login');
            return;
        }
        axios.get(`${baseURLAPI}users/get_profile?user_id=${userId}`)
            .then(response => {
                setProfile(response.data);
                if (response.data.data && response.data.data.wallet_balance !== undefined) {
                    setCurrentBalance(response.data.data.wallet_balance);
                }
            })
            .catch(error => console.error('Error fetching profile:', error));
    }, [navigate, baseURLAPI]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        if (params.get('payment') === 'success') {
            setSuccessModalOpen(true);
        }
    }, [location]);

    const handleAmountClick = (value) => {
        setAmount(value.toString());
        setSelectedAmount(value);
        setError('');
    };

    const handleInputChange = (e) => {
        const value = e.target.value;

        if (value === '' || /^[0-9\b]+$/.test(value)) {
            setAmount(value);
            setSelectedAmount(null);

            const numValue = parseInt(value, 10);
            if (value !== '' && numValue < 300) {
                setError('Minimum deposit amount is Rs 300');
            } else {
                setError('');
            }
        }
    };

    const clearAmount = () => {
        setAmount("");
        setSelectedAmount(null);
        setError('');
    };

    const handlePhoneChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 11);
        setPhoneNum(value);
    };

    const handleCNICChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 13);
        setCnicNumber(value);
    };

    const handleClose = () => {
        setOpen(false);
        setIsModalOpen(false);
        setPaymentStatus(null);
        setTrancLoading(false);
        setIsSubmitted(false);
    };

    const handleSuccessClose = () => {
        setSuccessModalOpen(false);
        // Optionally reload balance or page
        window.location.search = ''; // Clear query params
    };

    const handleOpen = () => {
        if (!amount || amount < 300) {
            setError('Minimum deposit amount is Rs. 300');
            return;
        }
        if (amount > 50000) {
            setError('Maximum deposit amount is Rs. 50,000');
            return;
        }
        setOpen(true);
        setIsModalOpen(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setTrancLoading(true);
        setIsModalOpen(true);
        setIsSubmitted(true);
        setError('');

        const userId = Cookies.get('user_id');
        if (!userId) {
            setTrancLoading(false);
            setError("User not logged in.");
            return;
        }

        if (!selectedPayment) {
            setTrancLoading(false);
            setError("Please select a payment method.");
            return;
        }

        if (selectedPayment === "USDT") {
            if (!networkLink) {
                setTrancLoading(false);
                setError("Please provide the USDT network verification link.");
                return;
            }
            try {
                const response = await axios.post(
                    `${baseURLAPI}Gateway/usdt_payment`,
                    {
                        user_id: userId,
                        amount: amount,
                        network_link: networkLink
                    }
                );

                if (response.data.status === 'success') {
                    setPaymentStatus('success');
                    setTimeout(() => {
                        navigate('/deposit', {
                            state: {
                                paymentSuccess: true,
                                amount: amount,
                                paymentMethod: selectedPayment
                            }
                        });
                    }, 2000);
                } else {
                    setPaymentStatus('failed');
                    setError(response.data.message || "USDT payment failed. Please try again.");
                }
            } catch (error) {
                console.error("USDT Payment Error:", error);
                setPaymentStatus('failed');
                setError(error.response?.data?.message || "USDT payment processing error.");
            } finally {
                setTrancLoading(false);
            }
            return;
        }

        if (!cnicNumber || cnicNumber.length !== 13) {
            setTrancLoading(false);
            setError("Please enter the last 13 digits of your CNIC.");
            return;
        }

        if (!phoneNum || phoneNum.length < 11) {
            setTrancLoading(false);
            setError("Please enter a valid 11-digit mobile number.");
            return;
        }

        if (!profile?.data?.email_id) {
            setTrancLoading(false);
            setError("Email is required. Please update your profile.");
            return;
        }

        const paymentMethodMap = {
            "EasyPaisa": "easypaisa",
            "JazzCash": "jazzcash",
            // "Raast Pay": "raast",
            "P2P Agent": "p2p"
        };

        const requestData = {
            user_id: userId,
            amount: amount,
            payment_method: paymentMethodMap[selectedPayment] || selectedPayment.toLowerCase(),
            serviceCode: "ewallet",
            product: `Deposit for User ${userId}`,
            platformURL: window.location.origin,
            cnic: cnicNumber,
            consumerNumber: phoneNum,
            email: profile.data.email_id,
            RemoteIP: '46.202.141.241',
            isSync: true
        };

        try {
            const response = await axios.post(
                `${baseURLAPI}Gateway/pay_with_agregga`,
                requestData,
                { headers: { "Content-Type": "application/json" } }
            );

            if (response.data.code === 3000 || response.data.status === 'success' || response.data.status === 1) {
                setPaymentStatus('success');

                // Compliance: Handle redirect URL if provided by Agregga/Billion Digit
                const redirectUrl = response.data.url || response.data.data?.url;
                if (redirectUrl) {
                    window.location.href = redirectUrl;
                    return;
                }

                setTimeout(() => {
                    navigate('/deposit', {
                        state: {
                            paymentSuccess: true,
                            amount: amount,
                            paymentMethod: selectedPayment
                        }
                    });
                }, 2000);
            } else if (response.data.code === 1000 || response.data.code === "1000") {
                // Handle redirect to checkout
                if (response.data.checkout_url) {
                    window.location.href = response.data.checkout_url;
                } else {
                    setPaymentStatus('failed');
                    setError("Missing checkout URL in response.");
                }
            } else {
                setPaymentStatus('failed');
                setError(response.data.message || "Payment failed. Please try again.");
            }
        } catch (error) {
            console.error("API Call Error:", error);
            setPaymentStatus('failed');
            setError(
                error.response?.data?.message ||
                error.message ||
                "Payment processing error. Please try again."
            );
        } finally {
            setTrancLoading(false);
        }
    };

    return (
        <>
            <div className="row">
                <div className="col-12">
                    <div className="deposite-card-inner">
                        <ul>
                            {paymentMethods.map((method) => (
                                <li
                                    key={method.id}
                                    onClick={() => {
                                        if (method.disabled) return;
                                        if (method.name === "P2P Agent") {
                                            navigate("/payment-agent");
                                            return;
                                        }
                                        setSelectedPayment(method.name);
                                        setError('');
                                        if (method.name === "USDT") {
                                            setOpen(true);
                                        }
                                    }}
                                    className={selectedPayment === method.name ? "selected-method" : ""}
                                    style={method.disabled ? { opacity: 0.5, cursor: "not-allowed" } : {}}
                                >
                                    <img src={method.img} alt={method.name} />
                                    {method.name === "P2P Agent" && (
                                        <img src={label} className="label-img" alt="Label" />
                                    )}
                                    <p>{method.name}</p>
                                    {method.disabled && <span className="coming-soon">Coming Soon</span>}
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <div className="deposit-amount">
                        <div className="deposit-amount-heading">
                            <img src={depositIcon} alt="Deposit Icon" />
                            <h3>Deposit amount</h3>
                        </div>
                        <ul>
                            {[500, 1000, 5000, 10000, 20000, 30000].map((value) => (
                                <li
                                    key={value}
                                    onClick={() => handleAmountClick(value)}
                                    className={selectedAmount === value ? "selected-amount" : ""}
                                >
                                    <span>Rs </span> {value >= 1000 ? `${value / 1000} K` : value}
                                </li>
                            ))}
                        </ul>
                        <div className="deposit-amount-input">
                            <label htmlFor="deposit-amount">Rs</label>
                            <input
                                type="text"
                                placeholder="Please enter the amount"
                                value={amount}
                                onChange={handleInputChange}
                                inputMode="numeric"
                            />
                            {amount && (
                                <img
                                    src={crosIcon}
                                    alt="Clear Icon"
                                    onClick={clearAmount}
                                    style={{ cursor: 'pointer' }}
                                />
                            )}
                        </div>
                        {error && <p className="error-message">{error}</p>}
                        <div className="text-center">
                            <button
                                className={`deposit-btn ${amount >= 300 ? 'active' : ''}`}
                                onClick={handleOpen}
                                disabled={!amount || amount < 300}
                            >
                                Deposit
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {open && (
                <div className="modal-overlay">
                    <div className="modal-content">
                        <h2 className="modal-title">
                            {selectedPayment === "USDT" ? "USDT Payment" : "Payment Deposit"}
                        </h2>

                        <div className="modal-body">
                            {selectedPayment === "USDT" ? (
                                <USDTForm
                                    amount={amount}
                                    networkLink={networkLink}
                                    setNetworkLink={setNetworkLink}
                                />
                            ) : (
                                <>
                                    <label>Mobile Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="03001234567"
                                        value={phoneNum}
                                        onChange={handlePhoneChange}
                                        maxLength={11}
                                        required
                                    />
                                    <label>Last 13 Digits of CNIC Number</label>
                                    <input
                                        type="text"
                                        placeholder="1234567890123"
                                        value={cnicNumber}
                                        onChange={handleCNICChange}
                                        maxLength={13}
                                        required
                                    />
                                    <p className="modal-warning">
                                        Please enter the correct information as it will be used for verification!
                                    </p>
                                </>
                            )}
                        </div>

                        <div className="modal-footer">
                            <button
                                className="confirm-btn"
                                onClick={handleSubmit}
                                disabled={trancLoading}
                            >
                                {trancLoading ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2"></span>
                                        Processing...
                                    </>
                                ) : "Confirm"}
                            </button>
                            {trancLoading && <PaymentLoader open={isModalOpen} />}
                            {isSubmitted && paymentStatus && !trancLoading && (
                                <PaymentStatus
                                    isSuccess={paymentStatus === "success"}
                                    message={paymentStatus === "success" ?
                                        "Payment successful! Redirecting..." :
                                        error || "Payment failed. Please try again."}
                                />
                            )}
                            <button
                                className="cancel-btn"
                                onClick={handleClose}
                                disabled={trancLoading}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

            {successModalOpen && (
                <div className="modal-overlay">
                    <div className="modal-content success-popup">
                        <h2>Payment Success</h2>
                        <p>Your Payment Successfully added into your wallet and your new balance is = {currentBalance}</p>
                        <button className="close-btn" onClick={handleSuccessClose}>Close</button>
                    </div>
                </div>
            )}

            <DepositRecharge />
        </>
    );
};

export default DepositMain;